import {useSelector} from "react-redux";
import {AppRootStateType} from "../../state/store";
import {ICategoriesResponseData} from "../../state/models/CategoriesResponse";
import {useAppDispatch} from "../useAppDispatch.ts";
import {IChannelResponseData} from "../../state/models/ChannelResponse.ts";
import {copyChannelLink} from "../../utils/Utils.ts";
import {
    removeChannelFromBlackListTC, removeChannelFromFavouritesTC,
    setChannelToBlackListTC,
    setChannelToFavouritesTC
} from "../../state/reducers/channel-reducer.ts";

const useChannelDetailsPage = () => {
    const dispatch = useAppDispatch();

    const isLoading = useSelector((state: AppRootStateType) => state.channels.currentChannel.isLoading);
    const channelData = useSelector<AppRootStateType, IChannelResponseData | null>(state => state.channels.currentChannel.data);
    const categoriesData = useSelector<AppRootStateType, ICategoriesResponseData[] | null>(state => state.categories.data);

    const selectedCategories = channelData?.categories && categoriesData ? categoriesData?.filter(category =>
        channelData?.categories.includes(category.id)
    ).map(i => i.title).join(', ') : '-'

    const userId =  localStorage.getItem("user_id")
    const conditionForAddingSinglePublication = userId !== channelData?.owner_id && channelData?.able_to_post

    const copyTelegramLink = () => {
        if(channelData?.telegram_channel_name) {
            copyChannelLink(channelData?.telegram_channel_username)
        }
    }

    const blackListHandler = () => {
        if(!channelData?.blacklisted && channelData){
            dispatch(setChannelToBlackListTC({channel_id: channelData?.id}))
        }else if(channelData?.blacklisted && channelData ){
            dispatch(removeChannelFromBlackListTC(channelData.id))
        }
    }
    const favouritesHandler = () => {
        if(!channelData?.favourite && channelData){
            dispatch(setChannelToFavouritesTC({channel_id: channelData?.id}))
        }else if(channelData?.favourite && channelData ){
            dispatch(removeChannelFromFavouritesTC(channelData.id))
        }
    }


    return {
        isLoading,
        channelData,
        selectedCategories,
        favouritesHandler,
        copyTelegramLink,
        blackListHandler, conditionForAddingSinglePublication
    };
};

export default useChannelDetailsPage;
